import React from 'react';

interface PaginationProps {
  page: number;
  recordsPerPage: number;
  setPage: (page: number) => void;
  setRecordsPerPage: (recordsPerPage: number) => void;
  totalRecords: number;
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  recordsPerPage,
  setPage,
  setRecordsPerPage,
  totalRecords
}) => (
  <div className="pagination-container">
    <div className="row">
      <div className="col-lg-4 col-md-6 col-sm-12">
        {totalRecords !== 0 && <div className="d-flex align-items-center">
          <select
            className="form-select"
            value={recordsPerPage}
            onChange={e => setRecordsPerPage(parseInt(e.target.value))}
            style={{ width: '80px' }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
          </select>
        </div>}
      </div>
      <div className="col-lg-8 col-md-6 col-sm-12 mt-3 mt-md-0">
        <nav aria-label="Page navigation example">
          <ul className="pagination justify-content-end">
            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setPage(page - 1)} aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
                <span className="sr-only">Previous</span>
              </button>
            </li>
            {Array.from({ length: Math.ceil(totalRecords / recordsPerPage) }).map((_, index) => (
              <li key={index} className={`page-item ${page === index + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => setPage(index + 1)}>{index + 1}</button>
              </li>
            ))}
            <li className={`page-item ${page === Math.ceil(totalRecords / recordsPerPage) ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setPage(page + 1)} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span className="sr-only">Next</span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
);

export default Pagination;